import React from "react";
import "./Table.css";

export const SimpleTable = (props) => {
  return (
    <section>
      <table className="container-table">
        <tbody className="thead_bottom">
          {props.col1.map((col1, index) => {
            return (
              <tr>
                <td>{props.col1[index]}</td>
                <td>{props.col2[index]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};
